/**
 * lightbox
 */
export module LightboxModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.setEvent();
      });
    }

    public static setEvent() {
      const $lightboxs = document.querySelectorAll('.lightbox[data-imagepath]');
      if($lightboxs){
        let $lightboxContainer = document.querySelector('#lightboxContainer');
        if(!$lightboxContainer){
          const $lightbox = document.createElement('div');
          $lightbox.classList.add('lightboxContainer');
          $lightbox.setAttribute('id','lightboxContainer');

          const $lightboxMain = document.createElement('div');
          $lightboxMain.classList.add('lightboxContainer__main');
          $lightbox.appendChild($lightboxMain);

          const $lightboxCloseButton = document.createElement('div');
          $lightboxCloseButton.classList.add('lightboxContainer__closeButton');
          $lightboxMain.appendChild($lightboxCloseButton);

          const $lightboxImageBox = document.createElement('div');
          $lightboxImageBox.classList.add('lightboxContainer__imageBox');
          $lightboxMain.appendChild($lightboxImageBox);

          document.body.appendChild($lightbox);

          $lightboxContainer = $lightbox;
        }

        $lightboxs.forEach($lightbox => {
          const $imagePath = $lightbox.getAttribute('data-imagepath');
          if($imagePath){
            const $imageBox = $lightboxContainer?.querySelector('.lightboxContainer__imageBox');
            const $lightboxMain = $lightboxContainer?.querySelector('.lightboxContainer__main');
            if($imageBox && $lightboxMain){
              $lightbox.addEventListener('click',$event => {
                const $oldImage = $imageBox.querySelector('img');
                const $clone = $imageBox.cloneNode( false );
                if(!$oldImage || $oldImage.getAttribute('src') !== $imagePath){
                  if($imageBox.parentNode){
                    $imageBox.parentNode.replaceChild( $clone , $imageBox );
                  }
                }

                const $image = document.createElement('img');
                $image.setAttribute('src',$imagePath);
                $image.setAttribute('alt','');
                $clone.appendChild($image);

                $lightboxMain.classList.add('lightboxContainer__main--isActive');

                return false;
              });
            }
          }
        });

        document.addEventListener('click',$event=>{
          const $eventTarget = $event.target as HTMLElement;
          if(
            $eventTarget &&
            !$eventTarget.classList.contains('lightboxContainer__imageBox') &&
            !$eventTarget.closest('.lightboxContainer__imageBox') &&
            (
              $eventTarget.classList.contains('lightboxContainer__main--isActive') ||
              $eventTarget.closest('.lightboxContainer__main--isActive')
            )
          ){
            const $lightboxMain = document.querySelector('.lightboxContainer__main');
            if($lightboxMain && $lightboxMain.classList.contains('lightboxContainer__main--isActive')){
              $lightboxMain.classList.remove('lightboxContainer__main--isActive');
            }
          }
        });
      }
    }
  }
}

